import React from "react"
import logoVietrade from '../assets/img/vietrade-official-logo.png'

export function VietradeLogo({ className = "", size = "md" }) {
  const sizeClasses = {
    sm: "w-16 h-16",
    md: "w-24 h-24",
    lg: "w-32 h-32",
  }

  return (
    <div
      className={`${sizeClasses[size] || sizeClasses.md} bg-white border border-gray-200 rounded-lg p-2 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 ${className}`}
    >
      <img
        src={logoVietrade}
        alt="Logo Cục Xúc tiến Thương mại Việt Nam - Vietrade"
        className="w-full h-full object-contain"
        onError={(e) => {
          e.currentTarget.src =
            "/placeholder.svg?height=100&width=100&text=VIETRADE"
        }}
      />
    </div>
  )
}
